import i18next from 'i18next';
i18next.loadNamespaces(['activity', 'exercise_types']);

/**
 * @param {{
 *   categoryKey: string;
 *   exerciseKey?: string;
 * }} exercise
 * @param {Function} [t]
 * @returns {string}
 */
export const getExerciseTranslation = (exercise, t) => {
    if (!exercise?.categoryKey) return '';

    /** @type {Function} */
    const tFunc = typeof t === 'function' ? t : i18next.t;

    const { categoryKey, exerciseKey } = exercise;
    if (categoryKey === 'UNKNOWN') {
        return tFunc('activity:choose_an_exercise');
    }
    return tFunc(`exercise_types:${categoryKey}_${exerciseKey || categoryKey}`);
};

export const getExerciseComposedKey = (exercise) => {
    return `${exercise.categoryKey}|${exercise.exerciseKey ? exercise.exerciseKey : ''}`;
};

export const extractExerciseFromComposedKey = (itemValue) => {
    const exerciseValues = itemValue.split('|');
    return {
        categoryKey: exerciseValues[0],
        exerciseKey: exerciseValues[1] ? exerciseValues[1] : null
    };
};

export const flattenExerciseTypes = (exerciseTypes, locale, isYogaOrPilates) => {
    if (!exerciseTypes.categories) {
        return [];
    }
    let flattenedExerciseTypes = [];

    const categoryKeys = Object.keys(exerciseTypes['categories']);
    categoryKeys.forEach((categoryKey) => {
        const exercises = exerciseTypes['categories'][categoryKey]['exercises'];

        let categoryHasExplicitExercise = false;
        const categoryGroupedExercises = Object.keys(exercises).map((exerciseKey) => {
            if (categoryKey === exerciseKey) {
                categoryHasExplicitExercise = true;
            }

            const exercise = exercises[exerciseKey];
            return {
                ...exercise,
                categoryKey: categoryKey,
                exerciseKey: exerciseKey,
                exerciseName: getExerciseTranslation({ exerciseKey, categoryKey }, isYogaOrPilates)
            };
        });

        if (!categoryHasExplicitExercise) {
            const categoryData = exerciseTypes['categories'][categoryKey];

            categoryGroupedExercises.push({
                isBodyWeight: null,
                counterpart: null,
                exerciseKey: categoryKey,
                exerciseName: getExerciseTranslation({ exerciseKey: categoryKey, categoryKey }, isYogaOrPilates),
                categoryKey: categoryKey,
                primaryMuscles: categoryData.primaryMuscles,
                secondaryMuscles: categoryData.secondaryMuscles
            });
        }

        flattenedExerciseTypes = flattenedExerciseTypes.concat(categoryGroupedExercises);
    });

    // Sort the exercises by name and consider the locale
    // > some exercise names in other languages have diacritics characters which need to be sorted correctly

    if (locale) {
        // make locale replace from _ to - to avoid incorrect local error
        const formattedLocal = locale.replace('_', '-');
        try {
            flattenedExerciseTypes.sort(function(a, b) {
                const aName = a.exerciseName.toLowerCase();
                const bName = b.exerciseName.toLowerCase();
                return aName.localeCompare(bName, formattedLocal, {
                    sensitivity: 'base',
                    ignorePunctuation: true
                });
            });
        } catch (e) {
            return flattenedExerciseTypes;
        }
    }

    return flattenedExerciseTypes;
};

export const isBodyWeightExercise = (categoryKey, exerciseKey, flattenedExerciseTypes) => {
    const exerciseType =
        flattenedExerciseTypes &&
        flattenedExerciseTypes.length > 0 &&
        flattenedExerciseTypes.find((ex) => ex.exerciseKey === exerciseKey && ex.categoryKey === categoryKey);

    return exerciseType && exerciseType.isBodyWeight;
};
